"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/search/v1/search.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchServiceClient = exports.SyncProjectsEvent = exports.FeaturedProjectsResponse = exports.FeaturedProjectsRequest = exports.LabelOrGroupI18n = exports.Label = exports.SearchProject_Collect = exports.SearchProject_OwnerData = exports.SearchProject = exports.SearchProjectsResponse = exports.SearchProjectsRequest_AroundMeFilter = exports.SearchProjectsRequest_CategoryFilter = exports.SearchProjectsRequest = exports.SearchMerchantsRequest = exports.SearchMerchantsResponse = exports.SyncProjectsResponse = exports.SyncProjectsRequest = exports.SyncAllProjectsResponse = exports.SyncAllProjectsRequest = exports.LabelFilter_Match = exports.LabelFilter = exports.Pagination = exports.searchProjectsRequest_PresetToJSON = exports.searchProjectsRequest_PresetFromJSON = exports.SearchProjectsRequest_Preset = void 0;
/* eslint-disable */
var collect_1 = require("../../common/v1/collect");
var geopoint_1 = require("../../common/v1/geopoint");
var health_1 = require("../../common/v1/health");
var project_state_1 = require("../../common/v1/project_state");
var project_type_1 = require("../../common/v1/project_type");
var term_frequency_1 = require("../../common/v1/term_frequency");
exports.SearchProjectsRequest_Preset = {
    PRESET_UNSPECIFIED: "PRESET_UNSPECIFIED",
    PRESET_SOON_FINISHED: "PRESET_SOON_FINISHED",
    PRESET_POPULAR: "PRESET_POPULAR",
    PRESET_NEWEST: "PRESET_NEWEST",
    PRESET_PINNED: "PRESET_PINNED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function searchProjectsRequest_PresetFromJSON(object) {
    switch (object) {
        case 0:
        case "PRESET_UNSPECIFIED":
            return exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED;
        case 1:
        case "PRESET_SOON_FINISHED":
            return exports.SearchProjectsRequest_Preset.PRESET_SOON_FINISHED;
        case 2:
        case "PRESET_POPULAR":
            return exports.SearchProjectsRequest_Preset.PRESET_POPULAR;
        case 3:
        case "PRESET_NEWEST":
            return exports.SearchProjectsRequest_Preset.PRESET_NEWEST;
        case 4:
        case "PRESET_PINNED":
            return exports.SearchProjectsRequest_Preset.PRESET_PINNED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.SearchProjectsRequest_Preset.UNRECOGNIZED;
    }
}
exports.searchProjectsRequest_PresetFromJSON = searchProjectsRequest_PresetFromJSON;
function searchProjectsRequest_PresetToJSON(object) {
    switch (object) {
        case exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED:
            return "PRESET_UNSPECIFIED";
        case exports.SearchProjectsRequest_Preset.PRESET_SOON_FINISHED:
            return "PRESET_SOON_FINISHED";
        case exports.SearchProjectsRequest_Preset.PRESET_POPULAR:
            return "PRESET_POPULAR";
        case exports.SearchProjectsRequest_Preset.PRESET_NEWEST:
            return "PRESET_NEWEST";
        case exports.SearchProjectsRequest_Preset.PRESET_PINNED:
            return "PRESET_PINNED";
        case exports.SearchProjectsRequest_Preset.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.searchProjectsRequest_PresetToJSON = searchProjectsRequest_PresetToJSON;
function createBasePagination() {
    return { items_per_page: 0, page: 0 };
}
exports.Pagination = {
    fromJSON: function (object) {
        return {
            items_per_page: isSet(object.items_per_page) ? globalThis.Number(object.items_per_page) : 0,
            page: isSet(object.page) ? globalThis.Number(object.page) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.items_per_page !== 0) {
            obj.items_per_page = Math.round(message.items_per_page);
        }
        if (message.page !== 0) {
            obj.page = Math.round(message.page);
        }
        return obj;
    },
    create: function (base) {
        return exports.Pagination.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBasePagination();
        message.items_per_page = (_a = object.items_per_page) !== null && _a !== void 0 ? _a : 0;
        message.page = (_b = object.page) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseLabelFilter() {
    return { must_matches: [] };
}
exports.LabelFilter = {
    fromJSON: function (object) {
        return {
            must_matches: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.must_matches)
                ? object.must_matches.map(function (e) { return exports.LabelFilter_Match.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.must_matches) === null || _a === void 0 ? void 0 : _a.length) {
            obj.must_matches = message.must_matches.map(function (e) { return exports.LabelFilter_Match.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.LabelFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLabelFilter();
        message.must_matches = ((_a = object.must_matches) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LabelFilter_Match.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseLabelFilter_Match() {
    return { label_group: 0, label: 0 };
}
exports.LabelFilter_Match = {
    fromJSON: function (object) {
        return {
            label_group: isSet(object.label_group) ? globalThis.Number(object.label_group) : 0,
            label: isSet(object.label) ? globalThis.Number(object.label) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.label_group !== 0) {
            obj.label_group = Math.round(message.label_group);
        }
        if (message.label !== 0) {
            obj.label = Math.round(message.label);
        }
        return obj;
    },
    create: function (base) {
        return exports.LabelFilter_Match.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLabelFilter_Match();
        message.label_group = (_a = object.label_group) !== null && _a !== void 0 ? _a : 0;
        message.label = (_b = object.label) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseSyncAllProjectsRequest() {
    return {};
}
exports.SyncAllProjectsRequest = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.SyncAllProjectsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseSyncAllProjectsRequest();
        return message;
    },
};
function createBaseSyncAllProjectsResponse() {
    return {};
}
exports.SyncAllProjectsResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.SyncAllProjectsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseSyncAllProjectsResponse();
        return message;
    },
};
function createBaseSyncProjectsRequest() {
    return { ids: [] };
}
exports.SyncProjectsRequest = {
    fromJSON: function (object) {
        return { ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.ids) ? object.ids.map(function (e) { return globalThis.Number(e); }) : [] };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.ids = message.ids.map(function (e) { return Math.round(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.SyncProjectsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseSyncProjectsRequest();
        message.ids = ((_a = object.ids) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseSyncProjectsResponse() {
    return {};
}
exports.SyncProjectsResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.SyncProjectsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseSyncProjectsResponse();
        return message;
    },
};
function createBaseSearchMerchantsResponse() {
    return { projects_ids: [], projects: [], total_projects: 0 };
}
exports.SearchMerchantsResponse = {
    fromJSON: function (object) {
        return {
            projects_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.projects_ids)
                ? object.projects_ids.map(function (e) { return globalThis.Number(e); })
                : [],
            projects: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.projects)
                ? object.projects.map(function (e) { return exports.SearchProject.fromJSON(e); })
                : [],
            total_projects: isSet(object.total_projects) ? globalThis.Number(object.total_projects) : 0,
        };
    },
    toJSON: function (message) {
        var _a, _b;
        var obj = {};
        if ((_a = message.projects_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.projects_ids = message.projects_ids.map(function (e) { return Math.round(e); });
        }
        if ((_b = message.projects) === null || _b === void 0 ? void 0 : _b.length) {
            obj.projects = message.projects.map(function (e) { return exports.SearchProject.toJSON(e); });
        }
        if (message.total_projects !== 0) {
            obj.total_projects = Math.round(message.total_projects);
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchMerchantsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseSearchMerchantsResponse();
        message.projects_ids = ((_a = object.projects_ids) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        message.projects = ((_b = object.projects) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.SearchProject.fromPartial(e); })) || [];
        message.total_projects = (_c = object.total_projects) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseSearchMerchantsRequest() {
    return {
        query: "",
        labels_filter: [],
        regional_code_filter: [],
        campaign_filter: [],
        branch_code: "",
        pagination: undefined,
        locale: undefined,
    };
}
exports.SearchMerchantsRequest = {
    fromJSON: function (object) {
        return {
            query: isSet(object.query) ? globalThis.String(object.query) : "",
            labels_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.labels_filter)
                ? object.labels_filter.map(function (e) { return exports.LabelFilter.fromJSON(e); })
                : [],
            regional_code_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.regional_code_filter)
                ? object.regional_code_filter.map(function (e) { return globalThis.String(e); })
                : [],
            campaign_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.campaign_filter)
                ? object.campaign_filter.map(function (e) { return globalThis.Number(e); })
                : [],
            branch_code: isSet(object.branch_code) ? globalThis.String(object.branch_code) : "",
            pagination: isSet(object.pagination) ? exports.Pagination.fromJSON(object.pagination) : undefined,
            locale: isSet(object.locale) ? globalThis.String(object.locale) : undefined,
        };
    },
    toJSON: function (message) {
        var _a, _b, _c;
        var obj = {};
        if (message.query !== "") {
            obj.query = message.query;
        }
        if ((_a = message.labels_filter) === null || _a === void 0 ? void 0 : _a.length) {
            obj.labels_filter = message.labels_filter.map(function (e) { return exports.LabelFilter.toJSON(e); });
        }
        if ((_b = message.regional_code_filter) === null || _b === void 0 ? void 0 : _b.length) {
            obj.regional_code_filter = message.regional_code_filter;
        }
        if ((_c = message.campaign_filter) === null || _c === void 0 ? void 0 : _c.length) {
            obj.campaign_filter = message.campaign_filter.map(function (e) { return Math.round(e); });
        }
        if (message.branch_code !== "") {
            obj.branch_code = message.branch_code;
        }
        if (message.pagination !== undefined) {
            obj.pagination = exports.Pagination.toJSON(message.pagination);
        }
        if (message.locale !== undefined) {
            obj.locale = message.locale;
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchMerchantsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f;
        var message = createBaseSearchMerchantsRequest();
        message.query = (_a = object.query) !== null && _a !== void 0 ? _a : "";
        message.labels_filter = ((_b = object.labels_filter) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.LabelFilter.fromPartial(e); })) || [];
        message.regional_code_filter = ((_c = object.regional_code_filter) === null || _c === void 0 ? void 0 : _c.map(function (e) { return e; })) || [];
        message.campaign_filter = ((_d = object.campaign_filter) === null || _d === void 0 ? void 0 : _d.map(function (e) { return e; })) || [];
        message.branch_code = (_e = object.branch_code) !== null && _e !== void 0 ? _e : "";
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? exports.Pagination.fromPartial(object.pagination)
            : undefined;
        message.locale = (_f = object.locale) !== null && _f !== void 0 ? _f : undefined;
        return message;
    },
};
function createBaseSearchProjectsRequest() {
    return {
        query: "",
        type_filter: project_type_1.ProjectType.PROJECT_TYPE_UNSPECIFIED,
        categories_filter: [],
        around_me_filter: undefined,
        state_filter: [],
        regional_code_filter: [],
        preset: exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED,
        legacy_pagination: undefined,
        pagination: undefined,
        campaign_filter: [],
        labels_filter: [],
        branch_code: "",
        locale: undefined,
        collect_type_filter: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
        partner_filter: [],
        hide_donation_under_progress_percentage: undefined,
        collect_goal_type_filter: [],
        slug_filter: [],
        hide_donation_failed_under_progress_percentage: undefined,
    };
}
exports.SearchProjectsRequest = {
    fromJSON: function (object) {
        return {
            query: isSet(object.query) ? globalThis.String(object.query) : "",
            type_filter: isSet(object.type_filter)
                ? (0, project_type_1.projectTypeFromJSON)(object.type_filter)
                : project_type_1.ProjectType.PROJECT_TYPE_UNSPECIFIED,
            categories_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.categories_filter)
                ? object.categories_filter.map(function (e) { return exports.SearchProjectsRequest_CategoryFilter.fromJSON(e); })
                : [],
            around_me_filter: isSet(object.around_me_filter)
                ? exports.SearchProjectsRequest_AroundMeFilter.fromJSON(object.around_me_filter)
                : undefined,
            state_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.state_filter)
                ? object.state_filter.map(function (e) { return (0, project_state_1.projectStateFromJSON)(e); })
                : [],
            regional_code_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.regional_code_filter)
                ? object.regional_code_filter.map(function (e) { return globalThis.String(e); })
                : [],
            preset: isSet(object.preset)
                ? searchProjectsRequest_PresetFromJSON(object.preset)
                : exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED,
            legacy_pagination: isSet(object.legacy_pagination) ? exports.Pagination.fromJSON(object.legacy_pagination) : undefined,
            pagination: isSet(object.pagination) ? exports.Pagination.fromJSON(object.pagination) : undefined,
            campaign_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.campaign_filter)
                ? object.campaign_filter.map(function (e) { return globalThis.Number(e); })
                : [],
            labels_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.labels_filter)
                ? object.labels_filter.map(function (e) { return exports.LabelFilter.fromJSON(e); })
                : [],
            branch_code: isSet(object.branch_code) ? globalThis.String(object.branch_code) : "",
            locale: isSet(object.locale) ? globalThis.String(object.locale) : undefined,
            collect_type_filter: isSet(object.collect_type_filter)
                ? (0, collect_1.collectTypeFromJSON)(object.collect_type_filter)
                : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            partner_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.partner_filter)
                ? object.partner_filter.map(function (e) { return globalThis.String(e); })
                : [],
            hide_donation_under_progress_percentage: isSet(object.hide_donation_under_progress_percentage)
                ? globalThis.Number(object.hide_donation_under_progress_percentage)
                : undefined,
            collect_goal_type_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.collect_goal_type_filter)
                ? object.collect_goal_type_filter.map(function (e) { return (0, collect_1.collectGoalTypeFromJSON)(e); })
                : [],
            slug_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.slug_filter)
                ? object.slug_filter.map(function (e) { return globalThis.String(e); })
                : [],
            hide_donation_failed_under_progress_percentage: isSet(object.hide_donation_failed_under_progress_percentage)
                ? globalThis.Number(object.hide_donation_failed_under_progress_percentage)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var obj = {};
        if (message.query !== "") {
            obj.query = message.query;
        }
        if (message.type_filter !== project_type_1.ProjectType.PROJECT_TYPE_UNSPECIFIED) {
            obj.type_filter = (0, project_type_1.projectTypeToJSON)(message.type_filter);
        }
        if ((_a = message.categories_filter) === null || _a === void 0 ? void 0 : _a.length) {
            obj.categories_filter = message.categories_filter.map(function (e) { return exports.SearchProjectsRequest_CategoryFilter.toJSON(e); });
        }
        if (message.around_me_filter !== undefined) {
            obj.around_me_filter = exports.SearchProjectsRequest_AroundMeFilter.toJSON(message.around_me_filter);
        }
        if ((_b = message.state_filter) === null || _b === void 0 ? void 0 : _b.length) {
            obj.state_filter = message.state_filter.map(function (e) { return (0, project_state_1.projectStateToJSON)(e); });
        }
        if ((_c = message.regional_code_filter) === null || _c === void 0 ? void 0 : _c.length) {
            obj.regional_code_filter = message.regional_code_filter;
        }
        if (message.preset !== exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED) {
            obj.preset = searchProjectsRequest_PresetToJSON(message.preset);
        }
        if (message.legacy_pagination !== undefined) {
            obj.legacy_pagination = exports.Pagination.toJSON(message.legacy_pagination);
        }
        if (message.pagination !== undefined) {
            obj.pagination = exports.Pagination.toJSON(message.pagination);
        }
        if ((_d = message.campaign_filter) === null || _d === void 0 ? void 0 : _d.length) {
            obj.campaign_filter = message.campaign_filter.map(function (e) { return Math.round(e); });
        }
        if ((_e = message.labels_filter) === null || _e === void 0 ? void 0 : _e.length) {
            obj.labels_filter = message.labels_filter.map(function (e) { return exports.LabelFilter.toJSON(e); });
        }
        if (message.branch_code !== "") {
            obj.branch_code = message.branch_code;
        }
        if (message.locale !== undefined) {
            obj.locale = message.locale;
        }
        if (message.collect_type_filter !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.collect_type_filter = (0, collect_1.collectTypeToJSON)(message.collect_type_filter);
        }
        if ((_f = message.partner_filter) === null || _f === void 0 ? void 0 : _f.length) {
            obj.partner_filter = message.partner_filter;
        }
        if (message.hide_donation_under_progress_percentage !== undefined) {
            obj.hide_donation_under_progress_percentage = Math.round(message.hide_donation_under_progress_percentage);
        }
        if ((_g = message.collect_goal_type_filter) === null || _g === void 0 ? void 0 : _g.length) {
            obj.collect_goal_type_filter = message.collect_goal_type_filter.map(function (e) { return (0, collect_1.collectGoalTypeToJSON)(e); });
        }
        if ((_h = message.slug_filter) === null || _h === void 0 ? void 0 : _h.length) {
            obj.slug_filter = message.slug_filter;
        }
        if (message.hide_donation_failed_under_progress_percentage !== undefined) {
            obj.hide_donation_failed_under_progress_percentage = Math.round(message.hide_donation_failed_under_progress_percentage);
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProjectsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var message = createBaseSearchProjectsRequest();
        message.query = (_a = object.query) !== null && _a !== void 0 ? _a : "";
        message.type_filter = (_b = object.type_filter) !== null && _b !== void 0 ? _b : project_type_1.ProjectType.PROJECT_TYPE_UNSPECIFIED;
        message.categories_filter =
            ((_c = object.categories_filter) === null || _c === void 0 ? void 0 : _c.map(function (e) { return exports.SearchProjectsRequest_CategoryFilter.fromPartial(e); })) || [];
        message.around_me_filter = (object.around_me_filter !== undefined && object.around_me_filter !== null)
            ? exports.SearchProjectsRequest_AroundMeFilter.fromPartial(object.around_me_filter)
            : undefined;
        message.state_filter = ((_d = object.state_filter) === null || _d === void 0 ? void 0 : _d.map(function (e) { return e; })) || [];
        message.regional_code_filter = ((_e = object.regional_code_filter) === null || _e === void 0 ? void 0 : _e.map(function (e) { return e; })) || [];
        message.preset = (_f = object.preset) !== null && _f !== void 0 ? _f : exports.SearchProjectsRequest_Preset.PRESET_UNSPECIFIED;
        message.legacy_pagination = (object.legacy_pagination !== undefined && object.legacy_pagination !== null)
            ? exports.Pagination.fromPartial(object.legacy_pagination)
            : undefined;
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? exports.Pagination.fromPartial(object.pagination)
            : undefined;
        message.campaign_filter = ((_g = object.campaign_filter) === null || _g === void 0 ? void 0 : _g.map(function (e) { return e; })) || [];
        message.labels_filter = ((_h = object.labels_filter) === null || _h === void 0 ? void 0 : _h.map(function (e) { return exports.LabelFilter.fromPartial(e); })) || [];
        message.branch_code = (_j = object.branch_code) !== null && _j !== void 0 ? _j : "";
        message.locale = (_k = object.locale) !== null && _k !== void 0 ? _k : undefined;
        message.collect_type_filter = (_l = object.collect_type_filter) !== null && _l !== void 0 ? _l : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.partner_filter = ((_m = object.partner_filter) === null || _m === void 0 ? void 0 : _m.map(function (e) { return e; })) || [];
        message.hide_donation_under_progress_percentage = (_o = object.hide_donation_under_progress_percentage) !== null && _o !== void 0 ? _o : undefined;
        message.collect_goal_type_filter = ((_p = object.collect_goal_type_filter) === null || _p === void 0 ? void 0 : _p.map(function (e) { return e; })) || [];
        message.slug_filter = ((_q = object.slug_filter) === null || _q === void 0 ? void 0 : _q.map(function (e) { return e; })) || [];
        message.hide_donation_failed_under_progress_percentage = (_r = object.hide_donation_failed_under_progress_percentage) !== null && _r !== void 0 ? _r : undefined;
        return message;
    },
};
function createBaseSearchProjectsRequest_CategoryFilter() {
    return { categories_hierarchy_id: [] };
}
exports.SearchProjectsRequest_CategoryFilter = {
    fromJSON: function (object) {
        return {
            categories_hierarchy_id: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.categories_hierarchy_id)
                ? object.categories_hierarchy_id.map(function (e) { return globalThis.Number(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.categories_hierarchy_id) === null || _a === void 0 ? void 0 : _a.length) {
            obj.categories_hierarchy_id = message.categories_hierarchy_id.map(function (e) { return Math.round(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProjectsRequest_CategoryFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseSearchProjectsRequest_CategoryFilter();
        message.categories_hierarchy_id = ((_a = object.categories_hierarchy_id) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseSearchProjectsRequest_AroundMeFilter() {
    return { location: undefined, max_kilometers: 0 };
}
exports.SearchProjectsRequest_AroundMeFilter = {
    fromJSON: function (object) {
        return {
            location: isSet(object.location) ? geopoint_1.GeoPoint.fromJSON(object.location) : undefined,
            max_kilometers: isSet(object.max_kilometers) ? globalThis.Number(object.max_kilometers) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.location !== undefined) {
            obj.location = geopoint_1.GeoPoint.toJSON(message.location);
        }
        if (message.max_kilometers !== 0) {
            obj.max_kilometers = Math.round(message.max_kilometers);
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProjectsRequest_AroundMeFilter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseSearchProjectsRequest_AroundMeFilter();
        message.location = (object.location !== undefined && object.location !== null)
            ? geopoint_1.GeoPoint.fromPartial(object.location)
            : undefined;
        message.max_kilometers = (_a = object.max_kilometers) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseSearchProjectsResponse() {
    return { projects_ids: [], projects: [], total_projects: 0 };
}
exports.SearchProjectsResponse = {
    fromJSON: function (object) {
        return {
            projects_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.projects_ids)
                ? object.projects_ids.map(function (e) { return globalThis.Number(e); })
                : [],
            projects: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.projects)
                ? object.projects.map(function (e) { return exports.SearchProject.fromJSON(e); })
                : [],
            total_projects: isSet(object.total_projects) ? globalThis.Number(object.total_projects) : 0,
        };
    },
    toJSON: function (message) {
        var _a, _b;
        var obj = {};
        if ((_a = message.projects_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.projects_ids = message.projects_ids.map(function (e) { return Math.round(e); });
        }
        if ((_b = message.projects) === null || _b === void 0 ? void 0 : _b.length) {
            obj.projects = message.projects.map(function (e) { return exports.SearchProject.toJSON(e); });
        }
        if (message.total_projects !== 0) {
            obj.total_projects = Math.round(message.total_projects);
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProjectsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseSearchProjectsResponse();
        message.projects_ids = ((_a = object.projects_ids) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        message.projects = ((_b = object.projects) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.SearchProject.fromPartial(e); })) || [];
        message.total_projects = (_c = object.total_projects) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseSearchProject() {
    return {
        project_id: 0,
        title: "",
        slug: "",
        category_ids: [],
        labels: [],
        image_file_name: undefined,
        teasing: false,
        place: "",
        short_description: "",
        state: project_state_1.ProjectState.PROJECT_STATE_UNSPECIFIED,
        owner_data: undefined,
        collect: undefined,
        longitude: 0,
        latitude: 0,
        wish_ends_at: undefined,
    };
}
exports.SearchProject = {
    fromJSON: function (object) {
        return {
            project_id: isSet(object.project_id) ? globalThis.Number(object.project_id) : 0,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            category_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.category_ids)
                ? object.category_ids.map(function (e) { return globalThis.Number(e); })
                : [],
            labels: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.labels)
                ? object.labels.map(function (e) { return exports.Label.fromJSON(e); })
                : [],
            image_file_name: isSet(object.image_file_name) ? globalThis.String(object.image_file_name) : undefined,
            teasing: isSet(object.teasing) ? globalThis.Boolean(object.teasing) : false,
            place: isSet(object.place) ? globalThis.String(object.place) : "",
            short_description: isSet(object.short_description) ? globalThis.String(object.short_description) : "",
            state: isSet(object.state) ? (0, project_state_1.projectStateFromJSON)(object.state) : project_state_1.ProjectState.PROJECT_STATE_UNSPECIFIED,
            owner_data: isSet(object.owner_data) ? exports.SearchProject_OwnerData.fromJSON(object.owner_data) : undefined,
            collect: isSet(object.collect) ? exports.SearchProject_Collect.fromJSON(object.collect) : undefined,
            longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
            latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
            wish_ends_at: isSet(object.wish_ends_at) ? globalThis.String(object.wish_ends_at) : undefined,
        };
    },
    toJSON: function (message) {
        var _a, _b;
        var obj = {};
        if (message.project_id !== 0) {
            obj.project_id = Math.round(message.project_id);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if ((_a = message.category_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.category_ids = message.category_ids.map(function (e) { return Math.round(e); });
        }
        if ((_b = message.labels) === null || _b === void 0 ? void 0 : _b.length) {
            obj.labels = message.labels.map(function (e) { return exports.Label.toJSON(e); });
        }
        if (message.image_file_name !== undefined) {
            obj.image_file_name = message.image_file_name;
        }
        if (message.teasing !== false) {
            obj.teasing = message.teasing;
        }
        if (message.place !== "") {
            obj.place = message.place;
        }
        if (message.short_description !== "") {
            obj.short_description = message.short_description;
        }
        if (message.state !== project_state_1.ProjectState.PROJECT_STATE_UNSPECIFIED) {
            obj.state = (0, project_state_1.projectStateToJSON)(message.state);
        }
        if (message.owner_data !== undefined) {
            obj.owner_data = exports.SearchProject_OwnerData.toJSON(message.owner_data);
        }
        if (message.collect !== undefined) {
            obj.collect = exports.SearchProject_Collect.toJSON(message.collect);
        }
        if (message.longitude !== 0) {
            obj.longitude = message.longitude;
        }
        if (message.latitude !== 0) {
            obj.latitude = message.latitude;
        }
        if (message.wish_ends_at !== undefined) {
            obj.wish_ends_at = message.wish_ends_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProject.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var message = createBaseSearchProject();
        message.project_id = (_a = object.project_id) !== null && _a !== void 0 ? _a : 0;
        message.title = (_b = object.title) !== null && _b !== void 0 ? _b : "";
        message.slug = (_c = object.slug) !== null && _c !== void 0 ? _c : "";
        message.category_ids = ((_d = object.category_ids) === null || _d === void 0 ? void 0 : _d.map(function (e) { return e; })) || [];
        message.labels = ((_e = object.labels) === null || _e === void 0 ? void 0 : _e.map(function (e) { return exports.Label.fromPartial(e); })) || [];
        message.image_file_name = (_f = object.image_file_name) !== null && _f !== void 0 ? _f : undefined;
        message.teasing = (_g = object.teasing) !== null && _g !== void 0 ? _g : false;
        message.place = (_h = object.place) !== null && _h !== void 0 ? _h : "";
        message.short_description = (_j = object.short_description) !== null && _j !== void 0 ? _j : "";
        message.state = (_k = object.state) !== null && _k !== void 0 ? _k : project_state_1.ProjectState.PROJECT_STATE_UNSPECIFIED;
        message.owner_data = (object.owner_data !== undefined && object.owner_data !== null)
            ? exports.SearchProject_OwnerData.fromPartial(object.owner_data)
            : undefined;
        message.collect = (object.collect !== undefined && object.collect !== null)
            ? exports.SearchProject_Collect.fromPartial(object.collect)
            : undefined;
        message.longitude = (_l = object.longitude) !== null && _l !== void 0 ? _l : 0;
        message.latitude = (_m = object.latitude) !== null && _m !== void 0 ? _m : 0;
        message.wish_ends_at = (_o = object.wish_ends_at) !== null && _o !== void 0 ? _o : undefined;
        return message;
    },
};
function createBaseSearchProject_OwnerData() {
    return { full_name: "", avatar_file_name: undefined, user_id: 0 };
}
exports.SearchProject_OwnerData = {
    fromJSON: function (object) {
        return {
            full_name: isSet(object.full_name) ? globalThis.String(object.full_name) : "",
            avatar_file_name: isSet(object.avatar_file_name) ? globalThis.String(object.avatar_file_name) : undefined,
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.full_name !== "") {
            obj.full_name = message.full_name;
        }
        if (message.avatar_file_name !== undefined) {
            obj.avatar_file_name = message.avatar_file_name;
        }
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProject_OwnerData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseSearchProject_OwnerData();
        message.full_name = (_a = object.full_name) !== null && _a !== void 0 ? _a : "";
        message.avatar_file_name = (_b = object.avatar_file_name) !== null && _b !== void 0 ? _b : undefined;
        message.user_id = (_c = object.user_id) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseSearchProject_Collect() {
    return {
        reserved: false,
        interests_ratio: 0,
        term_frequency: term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
        term_quantity: 0,
        type: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
        goal_type: collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED,
        goal_quantity: 0,
        goal_amount: 0,
        collected_quantity: 0,
        collected_amount: 0,
        progress: 0,
        is_cip: false,
        with_rewards: false,
        ends_at: undefined,
        really_ended_at: undefined,
    };
}
exports.SearchProject_Collect = {
    fromJSON: function (object) {
        return {
            reserved: isSet(object.reserved) ? globalThis.Boolean(object.reserved) : false,
            interests_ratio: isSet(object.interests_ratio) ? globalThis.Number(object.interests_ratio) : 0,
            term_frequency: isSet(object.term_frequency)
                ? (0, term_frequency_1.termFrequencyFromJSON)(object.term_frequency)
                : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
            term_quantity: isSet(object.term_quantity) ? globalThis.Number(object.term_quantity) : 0,
            type: isSet(object.type) ? (0, collect_1.collectTypeFromJSON)(object.type) : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            goal_type: isSet(object.goal_type)
                ? (0, collect_1.collectGoalTypeFromJSON)(object.goal_type)
                : collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED,
            goal_quantity: isSet(object.goal_quantity) ? globalThis.Number(object.goal_quantity) : 0,
            goal_amount: isSet(object.goal_amount) ? globalThis.Number(object.goal_amount) : 0,
            collected_quantity: isSet(object.collected_quantity) ? globalThis.Number(object.collected_quantity) : 0,
            collected_amount: isSet(object.collected_amount) ? globalThis.Number(object.collected_amount) : 0,
            progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
            is_cip: isSet(object.is_cip) ? globalThis.Boolean(object.is_cip) : false,
            with_rewards: isSet(object.with_rewards) ? globalThis.Boolean(object.with_rewards) : false,
            ends_at: isSet(object.ends_at) ? globalThis.String(object.ends_at) : undefined,
            really_ended_at: isSet(object.really_ended_at) ? globalThis.String(object.really_ended_at) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.reserved !== false) {
            obj.reserved = message.reserved;
        }
        if (message.interests_ratio !== 0) {
            obj.interests_ratio = message.interests_ratio;
        }
        if (message.term_frequency !== term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED) {
            obj.term_frequency = (0, term_frequency_1.termFrequencyToJSON)(message.term_frequency);
        }
        if (message.term_quantity !== 0) {
            obj.term_quantity = Math.round(message.term_quantity);
        }
        if (message.type !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.type = (0, collect_1.collectTypeToJSON)(message.type);
        }
        if (message.goal_type !== collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED) {
            obj.goal_type = (0, collect_1.collectGoalTypeToJSON)(message.goal_type);
        }
        if (message.goal_quantity !== 0) {
            obj.goal_quantity = Math.round(message.goal_quantity);
        }
        if (message.goal_amount !== 0) {
            obj.goal_amount = Math.round(message.goal_amount);
        }
        if (message.collected_quantity !== 0) {
            obj.collected_quantity = Math.round(message.collected_quantity);
        }
        if (message.collected_amount !== 0) {
            obj.collected_amount = Math.round(message.collected_amount);
        }
        if (message.progress !== 0) {
            obj.progress = Math.round(message.progress);
        }
        if (message.is_cip !== false) {
            obj.is_cip = message.is_cip;
        }
        if (message.with_rewards !== false) {
            obj.with_rewards = message.with_rewards;
        }
        if (message.ends_at !== undefined) {
            obj.ends_at = message.ends_at;
        }
        if (message.really_ended_at !== undefined) {
            obj.really_ended_at = message.really_ended_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.SearchProject_Collect.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var message = createBaseSearchProject_Collect();
        message.reserved = (_a = object.reserved) !== null && _a !== void 0 ? _a : false;
        message.interests_ratio = (_b = object.interests_ratio) !== null && _b !== void 0 ? _b : 0;
        message.term_frequency = (_c = object.term_frequency) !== null && _c !== void 0 ? _c : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED;
        message.term_quantity = (_d = object.term_quantity) !== null && _d !== void 0 ? _d : 0;
        message.type = (_e = object.type) !== null && _e !== void 0 ? _e : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.goal_type = (_f = object.goal_type) !== null && _f !== void 0 ? _f : collect_1.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED;
        message.goal_quantity = (_g = object.goal_quantity) !== null && _g !== void 0 ? _g : 0;
        message.goal_amount = (_h = object.goal_amount) !== null && _h !== void 0 ? _h : 0;
        message.collected_quantity = (_j = object.collected_quantity) !== null && _j !== void 0 ? _j : 0;
        message.collected_amount = (_k = object.collected_amount) !== null && _k !== void 0 ? _k : 0;
        message.progress = (_l = object.progress) !== null && _l !== void 0 ? _l : 0;
        message.is_cip = (_m = object.is_cip) !== null && _m !== void 0 ? _m : false;
        message.with_rewards = (_o = object.with_rewards) !== null && _o !== void 0 ? _o : false;
        message.ends_at = (_p = object.ends_at) !== null && _p !== void 0 ? _p : undefined;
        message.really_ended_at = (_q = object.really_ended_at) !== null && _q !== void 0 ? _q : undefined;
        return message;
    },
};
function createBaseLabel() {
    return { id: 0, i18n: [], label_group_id: 0, label_group_i18n: [] };
}
exports.Label = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            i18n: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.i18n) ? object.i18n.map(function (e) { return exports.LabelOrGroupI18n.fromJSON(e); }) : [],
            label_group_id: isSet(object.label_group_id) ? globalThis.Number(object.label_group_id) : 0,
            label_group_i18n: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.label_group_i18n)
                ? object.label_group_i18n.map(function (e) { return exports.LabelOrGroupI18n.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a, _b;
        var obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if ((_a = message.i18n) === null || _a === void 0 ? void 0 : _a.length) {
            obj.i18n = message.i18n.map(function (e) { return exports.LabelOrGroupI18n.toJSON(e); });
        }
        if (message.label_group_id !== 0) {
            obj.label_group_id = Math.round(message.label_group_id);
        }
        if ((_b = message.label_group_i18n) === null || _b === void 0 ? void 0 : _b.length) {
            obj.label_group_i18n = message.label_group_i18n.map(function (e) { return exports.LabelOrGroupI18n.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.Label.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseLabel();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.i18n = ((_b = object.i18n) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.LabelOrGroupI18n.fromPartial(e); })) || [];
        message.label_group_id = (_c = object.label_group_id) !== null && _c !== void 0 ? _c : 0;
        message.label_group_i18n = ((_d = object.label_group_i18n) === null || _d === void 0 ? void 0 : _d.map(function (e) { return exports.LabelOrGroupI18n.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseLabelOrGroupI18n() {
    return { locale: "", value: "" };
}
exports.LabelOrGroupI18n = {
    fromJSON: function (object) {
        return {
            locale: isSet(object.locale) ? globalThis.String(object.locale) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.locale !== "") {
            obj.locale = message.locale;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function (base) {
        return exports.LabelOrGroupI18n.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLabelOrGroupI18n();
        message.locale = (_a = object.locale) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseFeaturedProjectsRequest() {
    return { branch_code: "", locale: undefined };
}
exports.FeaturedProjectsRequest = {
    fromJSON: function (object) {
        return {
            branch_code: isSet(object.branch_code) ? globalThis.String(object.branch_code) : "",
            locale: isSet(object.locale) ? globalThis.String(object.locale) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.branch_code !== "") {
            obj.branch_code = message.branch_code;
        }
        if (message.locale !== undefined) {
            obj.locale = message.locale;
        }
        return obj;
    },
    create: function (base) {
        return exports.FeaturedProjectsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseFeaturedProjectsRequest();
        message.branch_code = (_a = object.branch_code) !== null && _a !== void 0 ? _a : "";
        message.locale = (_b = object.locale) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseFeaturedProjectsResponse() {
    return { projects: [] };
}
exports.FeaturedProjectsResponse = {
    fromJSON: function (object) {
        return {
            projects: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.projects)
                ? object.projects.map(function (e) { return exports.SearchProject.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.projects) === null || _a === void 0 ? void 0 : _a.length) {
            obj.projects = message.projects.map(function (e) { return exports.SearchProject.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.FeaturedProjectsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseFeaturedProjectsResponse();
        message.projects = ((_a = object.projects) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.SearchProject.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseSyncProjectsEvent() {
    return { project_ids: [] };
}
exports.SyncProjectsEvent = {
    fromJSON: function (object) {
        return {
            project_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.project_ids)
                ? object.project_ids.map(function (e) { return globalThis.Number(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.project_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.project_ids = message.project_ids.map(function (e) { return Math.round(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.SyncProjectsEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseSyncProjectsEvent();
        message.project_ids = ((_a = object.project_ids) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var SearchServiceClient = /** @class */ (function () {
    function SearchServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    SearchServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    SearchServiceClient.prototype.SyncProjects = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.SyncProjectsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/SyncProjects";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.SyncProjectsResponse.fromJSON, options)];
            });
        });
    };
    SearchServiceClient.prototype.SyncAllProjects = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.SyncAllProjectsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/SyncAllProjects";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.SyncAllProjectsResponse.fromJSON, options)];
            });
        });
    };
    SearchServiceClient.prototype.SearchProjects = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.SearchProjectsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/SearchProjects";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.SearchProjectsResponse.fromJSON, options)];
            });
        });
    };
    SearchServiceClient.prototype.SearchMerchants = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.SearchMerchantsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/SearchMerchants";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.SearchMerchantsResponse.fromJSON, options)];
            });
        });
    };
    SearchServiceClient.prototype.FeaturedProjects = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FeaturedProjectsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.search.v1.SearchService/FeaturedProjects";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FeaturedProjectsResponse.fromJSON, options)];
            });
        });
    };
    return SearchServiceClient;
}());
exports.SearchServiceClient = SearchServiceClient;
//# sourceMappingURL=search.js.map